import React from "react";

import { Text } from "@react-pdf/renderer";
import PdfSection from "../../components/layout/PdfSection";
import PdfSectionTitle from "../../components/typography/PdfSectionTitle";
import PdfColumn from "../../components/layout/PdfColumn";

const PDfBuilderSectionUploadedDocuments = ({
  title = "Uploaded Documents",
  documents,
}) => {
  return (
    <PdfSection>
      <PdfSectionTitle>{title}</PdfSectionTitle>
      <PdfDocumentListContainer>
        {documents && documents?.length > 0 ? (
          documents?.map((file, index) => (
            <PdfFileItem key={index}>
              • {file.file_display_name} {file?.docType && `(${file.docType})`}
            </PdfFileItem>
          ))
        ) : (
          <PdfFileItem>No files uploaded</PdfFileItem>
        )}
      </PdfDocumentListContainer>
    </PdfSection>
  );
};
const PdfDocumentListContainer = ({ children }) => (
  <PdfColumn>{children}</PdfColumn>
);

const PdfFileItem = ({ children }) => (
  <Text style={{ fontSize: 9, marginBottom: 4, color: "#000000" }}>
    {children}
  </Text>
);

export default PDfBuilderSectionUploadedDocuments;
